module.exports = __webpack_public_path__ + "img/Logo-martinez-vertical.24ffb148.png";